// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"559":"097d3daf","754":"097d3daf","805":"d8c58e69"}[chunkId] + ".chunk.css";
};